import { startTransition, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FOLDER_NAME_MAX_LENGTH } from "../../constants";
import type { FolderNameInputProps } from "./types";

// A keystroke re-renders only this input; the plan list follows in an interruptible transition
export const FolderNameInput = ({
  folderKey,
  name,
  isDisabled,
  onRename,
}: FolderNameInputProps) => {
  const { t } = useTranslation();

  const [typedName, setTypedName] = useState(name);

  const changeName = useCallback(
    (nextName: string) => {
      setTypedName(nextName);
      // A blank name is never saved, so the folder keeps its last name.
      if (nextName.trim() === "") return;
      startTransition(() => onRename(folderKey, nextName));
    },
    [folderKey, onRename],
  );

  return (
    <input
      type="text"
      value={typedName}
      maxLength={FOLDER_NAME_MAX_LENGTH}
      aria-label={t("smartSurveyor.folders.suggestion.folderName")}
      placeholder={name}
      onChange={(event) => changeName(event.target.value)}
      disabled={isDisabled}
      className="min-w-0 flex-1 rounded-md border border-gray-300 bg-white px-2 py-1 font-semibold text-gray-900 focus:border-blue-500 focus:outline-none"
    />
  );
};
